const validate = (values, props) => {

    let errors = {};

    if (!values.email) {
        errors.email = 'Required';
    }

    if (!values.password) {
        errors.password = 'Required';
    }


    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./assets/app/login/components/LoginForm/validate.js